import React from 'react';
import PropTypes from 'prop-types';
import { useTabsNavigationStore } from '../../../stores';
import { useApiPost } from '../../../api/hooks';
import { getSeasonFromDate } from '../../../utils/season';

const CREATE_SHIFT_URL = '/api/camps/admin/smena/new';

// .btn.btn-primary «Создать смену» — создание смены + авто-переход на неё.
export default function CreateShiftButton({ refetchShifts }) {
    const setShiftWithSeason = useTabsNavigationStore(state => state.setShiftWithSeason);

    const createShift = useApiPost({
        successMessage: 'Смена создана',
        withPreloader: true,
        onSuccess: async (data) => {
            await refetchShifts();
            setShiftWithSeason(data.id, getSeasonFromDate(data.startDate));
        }
    });

    const handleCreate = () => {
        createShift.mutate({ url: CREATE_SHIFT_URL, data: null });
    };

    return (
        <button type="button" className="btn btn-primary" onClick={handleCreate}>
            Создать смену
        </button>
    );
}

CreateShiftButton.propTypes = {
    refetchShifts: PropTypes.func.isRequired
};
